var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 8,
    viewBox: "0 0 11 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2814 0.469116C10.5744 0.762085 10.5744 1.23787 10.2814 1.53083L4.28144 7.53084C3.98848 7.8238 3.51269 7.8238 3.21973 7.53084L0.219727 4.53084C-0.0732422 4.23787 -0.0732422 3.76209 0.219727 3.46912C0.512695 3.17615 0.988476 3.17615 1.28145 3.46912L3.75176 5.93709L9.22207 0.469116C9.51504 0.176147 9.99082 0.176147 10.2838 0.469116H10.2814Z",
    fill: "#E53539"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCheck);
export default __webpack_public_path__ + "static/media/red_check.3fe8364654f99162375234ab7e34a786.svg";
export { ForwardRef as ReactComponent };